import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { Pressable, Text, View } from 'react-native';
import { ButtonContainer, ButtonGroup, Button  } from '../../elements/buttons';
import SubNav from './SubNav';
import Input from '../../elements/inputs';
import Modal from '../../elements/Modal';
import { SETTING, UPDATE_SETTING } from './queries';
import DataState from '../DataState';

function Settings({setShowModal}) {
  const { loading, error, data, refetch } = useQuery(
    SETTING, { variables: {} }
  );

  const [updateSetting] = useMutation(UPDATE_SETTING, {
    onCompleted: () => {
      setShowModal(false);
    }
  });

  const { control, reset, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      storageFeeText: '',
      lastPurchaseOrderNumber: '',
      nextInvoiceNumber: '',
      processingFee: '0.00',
      booksClosedOn: '',
      preReleaseResendDays: 0
    }
  });

  useEffect(() => {
    if(data !== undefined) {
      reset({
        storageFeeText: data.settings.storageFeeText || '',
        lastPurchaseOrderNumber: data.settings.lastPurchaseOrderNumber || '',
        nextInvoiceNumber: data.settings.nextInvoiceNumber || '',
        processingFee: data.settings.processingFee || '0.00',
        booksClosedOn: data.settings.booksClosedOn || '',
        featuredBlogLabel: data.settings.featuredBlogLabel || 'Featured',
        preReleaseResendDays: data.settings.preReleaseResendDays || 0
      })
    }
  }, [data])

  const onSubmit = (data) => {
    data.nextInvoiceNumber =
      data.nextInvoiceNumber ? parseInt(data.nextInvoiceNumber) : 1;
    data.preReleaseResendDays =
      data.preReleaseResendDays ? parseInt(data.preReleaseResendDays) : 0;
    if (data.booksClosedOn === '') { data.booksClosedOn = null; }
    if (data.processingFee === '') { data.processingFee = '0'; }
    if(data['featuredBlogLabel'] === '' ||
    data['featuredBlogLabel'] === undefined
    ) data['featuredBlogLabel'] = 'Featured'
    updateSetting({ variables: data });
  };

  return (
    <View>
        <View>
          <Input.TextArea
            label="Default Storage Fee Text for Releases:"
            name="storageFeeText"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Next Invoice Number"
            name="nextInvoiceNumber"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Invoice Processing Fee"
            name="processingFee"
            control={control}
            errors={errors}
          />
          <Input.Date
            label="Books Closed On"
            name="booksClosedOn"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Featured Blog Label"
            name="featuredBlogLabel"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="How many days after a Pre-Release Title Email is sent do we send the next one?"
            name="preReleaseResendDays"
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Submit" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
    </View>
  )
};

export default Settings;
